import { ClientPathSchema } from '@/features/dashboard/client/clientSchema'
import { IdentificationEditPage } from '@/features/dashboard/client/detail/components/identification-edit/pages/IdentificationEditPage'
import { usePageTitle } from '@/hooks/usePageTitle'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { IdentificationEditReturnTo } from '@/features/dashboard/client/identification-list/identificationListEnum'
import { IdentificationSearchSchema } from '@/features/dashboard/client/identification-list/identificationListSchema'

// 本人確認情報編集画面の検索パラメータ
// IdentificationSearchSchemaにreturnToを追加
const IdentificationEditSearchSchema = IdentificationSearchSchema.extend({
  returnTo: z.enum(Object.values(IdentificationEditReturnTo)).optional(),
});

export const Route = createFileRoute('/_dashboard/clients/$clientId/identification/edit')({
  component: RouteComponent,
  parseParams: ClientPathSchema.parse,
  validateSearch: IdentificationEditSearchSchema,
})

function RouteComponent() {
  usePageTitle('本人確認情報編集')
  return <IdentificationEditPage />
}
